import React from 'react';
import classes from './SuccessScreen.module.css';
import sallyImage from '../../assets/sally_success.png';

const successScreen = (props) => {
    return (
        <div className={classes.Container}>
            <img src={sallyImage} alt="Sally" width="220" />
            <p>النموذج اتبعت بنجاح وهبعتلك رقمه.</p>
          
            <button onClick={props.exit}>خروج</button>
            <p className={classes.Countdown}>إغلاق بعد &nbsp; {props.countdown}</p>
        </div>
    );
}
export default successScreen;

